<template>
  <main class="handyrechnung-stores">
    <DcbStoresHero />
    <DcbStoresMailForm
      id="mail-form"
      v-reveal
      :step="step"
      @mail-sent="step = 'mailSent'"
    />
    <DcbStoresStepsBonus v-reveal />
    <DcbStoresWofuerSection v-reveal />
    <DcbStoresWhySection v-reveal />
    <DcbStoresComparisonTable v-reveal />
    <DcbStoresFaq v-reveal />
    <DcbStoresCta v-reveal />

    <DcbStickyButton
      label="Cashback sichern"
      :target-selectors="['#mail-form', '.handyrechnung-stores__faq']"
    />
  </main>
</template>

<script setup lang="ts">
import { getHeader } from '~/helpers/page-header-compositon';
import { Track } from '~/helpers/page-tracking';
import { type DcbStep, useDoubleOptIn } from '~/lib/dcb/dcb-double-opt-in';
import { useFeatures } from '~/composables/use-features';

definePageMeta({
  props: {
    isIndexed: false,
  },
});

Track({ page_type: 'theme.landing' });

getHeader({
  title: ref('100 % Cashback auf deinen 1. In-App-Kauf | Telekom'),
  description: ref(
    'Apps, Abos und In-App-Käufe im App Store und Google Play Store per Telekom Handyrechnung zahlen. Ohne Karte, ohne Bankkonto. Für deinen ersten Kauf gibt es bis zu 10 € zurück.'
  ),
});

const { features } = useFeatures();
const step = ref<DcbStep>('form');

useDoubleOptIn(step);

onMounted(() => {
  if (features.dcbMailSent.enabled) {
    step.value = 'mailSent';
  }
});
</script>

<style scoped lang="scss">
@use 'assets/base' as *;

.handyrechnung-stores {
  &__footnote {
    display: flex;
    justify-content: center;
    padding-block: 1rem 2rem;
  }
}
</style>
